import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lfwms-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
/*@author: abidhmuhsinp
*/
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/footer/footer.component.ts